<ng-scrollbar visibility="hover">
  <div class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
    <h1>{{ 'account.title' | translate }}</h1>
    <h4>{{ 'account.sub_title' | translate }}</h4>
    <br>
    <div class="card-wrapper">

      <section *ngIf="!(roles$|async).includes(Roles.ROLE_DIRECT_CORPORATE_ADMIN) &&
              (
                ((this.user$|async).type === Roles.ROLE_INSURER || (this.user$|async).type === Roles.ROLE_BROKER || (this.user$|async).type === Roles.ROLE_UNDERWRITER) ||
                (this.user$|async).isRepresentative === true
              )">
        <label class="title w-100">{{'account.menu.email_notifications.title' | translate}}</label>
        <mat-slide-toggle class="slider description" (change)="toggleNotificationsVisible()"
                          [checked]="notificationsVisible"
                          labelPosition="after"><b>{{'account.menu.email_notifications.switch' | translate}}</b></mat-slide-toggle>
        <p *ngIf="!notificationsVisible"
           class="description w-100">{{'account.menu.email_notifications.description.1' | translate}} <b>{{('account.menu.email_notifications.inactive' | translate)}}</b>.
           {{'account.menu.email_notifications.description.2' | translate}}
          <b>{{'account.menu.email_notifications.none' | translate}}</b>
          {{'account.menu.email_notifications.description.3' | translate}}</p>

        <mat-accordion [multi]="true" displayMode="flat" class="accordion-container" *ngIf="notificationsVisible">

          <!-- eMail title -->
          <mat-grid-list cols="2" rowHeight="40px" style="width: 725px; max-width: 100%; height: 100%;">
            <mat-grid-tile-header>
              <mat-grid-tile></mat-grid-tile>
              <mat-grid-tile *ngFor="let channel of Object.values(NotificationChannel)">
                <img src="assets/img/email/email_logo.png" alt="eMail Logo" style="height: 30px; width: auto; padding-bottom: 6px;">
                {{ 'account.menu.email_notifications.channels.' + channel | translate }}
              </mat-grid-tile>
            </mat-grid-tile-header>
          </mat-grid-list>

          <!-- Proposal notifications -->
          <mat-expansion-panel [togglePosition]="'before'" *ngIf="notificationsVisible &&
              ((this.user$|async).type === Roles.ROLE_INSURER || (this.user$|async).type === Roles.ROLE_BROKER || (this.user$|async).type === Roles.ROLE_UNDERWRITER)" [expanded]="notificationsProposalVisible">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                <h4 style="margin-bottom: 0 !important;"><b>{{'account.menu.email_notifications.notificationsProposalTitle' | translate}}</b></h4>
                <!-- fraction container -->
                <div class="fraction-container">
                  <span>{{ this.notificationsNumberProposal }}</span>
                  <span>/</span>
                  <span>{{ this.totalNumberNotificationsProposal }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-notification-preferences [notificationType]="NotificationType.PROPOSAL" [onUpdate]="updateNotificationPreferences.bind(this)"></app-notification-preferences>
          </mat-expansion-panel>

          <hr *ngIf="notificationsVisible &&
              ((this.user$|async).type === Roles.ROLE_INSURER || (this.user$|async).type === Roles.ROLE_BROKER || (this.user$|async).type === Roles.ROLE_UNDERWRITER)">

          <!-- Offer notifications -->
          <mat-expansion-panel [togglePosition]="'before'" *ngIf="notificationsVisible &&
              ((this.user$|async).type === Roles.ROLE_INSURER || (this.user$|async).type === Roles.ROLE_BROKER || (this.user$|async).type === Roles.ROLE_UNDERWRITER)" [expanded]="notificationsOfferVisible">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                <h4 style="margin-bottom: 0 !important;"><b>{{'account.menu.email_notifications.notificationsOfferTitle' | translate}}</b></h4>
                <!-- fraction container -->
                <div class="fraction-container">
                  <span>{{ this.notificationsNumberOffer }}</span>
                  <span>/</span>
                  <span>{{ this.totalNumberNotificationsOffer }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-notification-preferences [notificationType]="NotificationType.OFFER" [onUpdate]="updateNotificationPreferences.bind(this)"></app-notification-preferences>
          </mat-expansion-panel>

          <hr *ngIf="notificationsVisible &&
              ((this.user$|async).type === Roles.ROLE_INSURER || (this.user$|async).type === Roles.ROLE_BROKER || (this.user$|async).type === Roles.ROLE_UNDERWRITER)">

          <!-- Member area notifications -->
          <mat-expansion-panel [togglePosition]="'before'" *ngIf="notificationsVisible && (this.user$|async).isRepresentative === true" [expanded]="notificationsMemberAreaVisible">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                <h4 style="margin-bottom: 0 !important;"><b>{{'account.menu.email_notifications.notificationsMemberAreaTitle' | translate}}</b></h4>
                <!-- fraction container -->
                <div class="fraction-container">
                  <span>{{ this.notificationsNumberMemberArea }}</span>
                  <span>/</span>
                  <span>{{ this.totalNumberNotificationsMemberArea }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-notification-preferences [notificationType]="NotificationType.MEMBER_AREA" [onUpdate]="updateNotificationPreferences.bind(this)"></app-notification-preferences>
          </mat-expansion-panel>
        </mat-accordion>

        <hr style="margin: 0;" *ngIf="notificationsVisible && (this.user$|async).isRepresentative === true">
      </section>

      <!-- System language -->
      <section style="margin-top: 2rem; margin-bottom: 0;">
        <label class="title w-100" style="margin-bottom: 0.2rem !important;">{{'account.menu.language.title' | translate}}</label>
        <app-input-field class="field-container"
                         [label]="'account.menu.language.subtitle' | translate">
          <mat-select class="input w-25" data-cy="language-chooser"
                      [(value)]="lang" #singleSelect (selectionChange)="changeLanguage()">
            <mat-option *ngFor="let opt of languages" [value]="opt">
              {{'account.menu.language.option.' + opt | translate}}
            </mat-option>

          </mat-select>
        </app-input-field>
      </section>

      <hr>

      <!-- Services -->
      <section *ngIf="!(roles$|async).includes(Roles.ROLE_DIRECT_CORPORATE_ADMIN)">
        <span class="title w-100">{{'account.menu.kis.title' | translate}}</span>
        <h4 style="margin-top: 1rem; margin-bottom: 1rem;"><b>{{'account.menu.kis.subtitle' | translate}}</b></h4>
        <!-- KIS -->
        <div class="d-flex flex-column kis-selection" style="margin-bottom: 0.5rem;">
          <mat-slide-toggle class="slider description" data-cy="kis-selection"
                            (change)="toggleKisSwitch()" [checked]="kisSwitch"
                            labelPosition="after">
            <b>
              <img src="assets/img/kis/kis_logo.png" alt="KIS Logo" style="height: 18px; width: auto; margin-right: 4px; padding-bottom: 2px;">

              {{'account.menu.kis.switch' | translate}}
            </b>
          </mat-slide-toggle>
          <div *ngIf="kisSwitch" class="d-flex flex-row gap-5" [formGroup]="kisFormGroup">
            <app-input-field [control]="kisFormGroup.controls.username" class="smaller-input"
                             [label]="'account.menu.kis.username'|translate">
              <input name="username" formControlName="username"
                     class="input">
            </app-input-field>

            <app-input-field [control]="kisFormGroup.controls.password" class="smaller-input"
                             [label]="'account.menu.kis.password'|translate">
              <input name="password" formControlName="password"
                     class="input" type="password">
            </app-input-field>
          </div>
          <button *ngIf="kisSwitch" class="menu-button next-button w-25" style="margin-bottom: 2rem;" (click)="openConfirmationMatDialog()">{{ "account.menu.kis.save"|translate }}</button>
        </div>

        <!-- SkenData -->
        <div class="d-flex flex-column kis-selection">
          <mat-slide-toggle class="slider description" data-cy="skendata-selection"
                            (change)="toggleSkenDataSwitch()" [checked]="skenDataSwitch"
                            labelPosition="after">
            <b>
              <img src="assets/img/skendata/skendata_logo_full.png" alt="SkenData Logo" style="height: 14px; width: auto; margin-right: 4px; padding-bottom: 2px;">

              {{'account.menu.skendata.switch' | translate}}
            </b>
          </mat-slide-toggle>
          <div *ngIf="skenDataSwitch" class="d-flex flex-row gap-5" [formGroup]="skenDataFormGroup">
            <app-input-field [control]="skenDataFormGroup.controls.skenDataAccountId" class="smaller-input"
                             [label]="'account.menu.skendata.username'|translate">
              <input name="skenDataAccountId" formControlName="skenDataAccountId"
                     class="input">
            </app-input-field>
            <button *ngIf="skenDataSwitch && skenDataFormGroup.controls.skenDataAccountId.value.toString().length > 0" class="blue-border w-fit-content" (click)="jumpToSkenData()">{{ "account.menu.skendata.jumpToSkenData"|translate }}</button>
            <button *ngIf="skenDataSwitch && skenDataFormGroup.controls.skenDataAccountId.value.toString().length === 0" class="blue-border w-fit-content" (click)="jumpToSkenData()">{{ "account.menu.skendata.registerWithSkenData"|translate }}</button>

          </div>
        </div>
      </section>

      <hr *ngIf="(user$|async).type === Roles.ROLE_BROKER || (user$|async).type === Roles.ROLE_INSURER || (user$|async).type === Roles.ROLE_UNDERWRITER">

      <!-- Choose a representative -->
      <section style="margin-top: 2rem; margin-bottom: 0;" *ngIf="(user$|async).type === Roles.ROLE_BROKER || (user$|async).type === Roles.ROLE_INSURER || (user$|async).type === Roles.ROLE_UNDERWRITER" >
        <label class="title w-100" style="margin-bottom: 0.2rem !important;">{{'account.menu.representative.title' | translate}}</label>
        <app-input-field class="field-container"
                         [label]="'account.menu.representative.subtitle' | translate">
          <mat-select class="input w-25"
                      placeholder="{{ 'account.menu.representative.none' | translate }}"
                      [(value)]="selectedRepresentative" [compareWith]="compareFn" (selectionChange)="changeRepresentative()">

            <mat-option [value]="null">{{'account.menu.representative.none' | translate}}</mat-option>
            <mat-option *ngFor="let opt of representatives" [value]="opt">
              {{opt.firstName}} {{opt.lastName}} ({{opt.email}})
            </mat-option>

          </mat-select>
        </app-input-field>
      </section>

      <hr>


      <!-- Password change -->
      <section>
        <span class="title">{{'account.menu.password_change.title' | translate}}</span>
        <p class="description">{{'account.menu.password_change.description.1' | translate}}</p>
        <p class="description">{{'account.menu.password_change.description.2' | translate}}</p>

        <button class="menu-button next-button w-25"
                matTooltip="{{'account.menu.password_change.description.1' | translate}}"
                (click)="resetPassword()">
          {{'account.menu.password_change.title' | translate}}
        </button>
      </section>




    </div>
  </div>
</ng-scrollbar>
